<template>

  <template v-if="(typeof $route.params.id === 'undefined')">

    <!--################################################# ESCOLHER SALA DE AULA #########################################################################-->
    <template v-if="$route.params.aPage === 'Prova'">
      <v-container fluid>
        <v-data-table v-model:sort-by="sortByProf" class="table elevation-2" hover
          items-per-page-text="Itens por página" page-text="{0}-{1} de {2}" 
          :headers="headersClassrooms" :items="listClassrooms" :loading="loadingClassrooms"
          @click:row="rowClick">
              <template v-slot:no-data>
                <v-alert class="my-4" :value="true">
                  <v-icon class="mt-n1 mr-2" color="warning" icon="mdi-alert" /> Desculpe, sem dados para exibir :(
                </v-alert>
              </template>
        </v-data-table>
      </v-container>

      <v-dialog v-model="dialogClassPwd" max-width="500px">
        <v-card>
          <v-toolbar class="bg-primary-darken-1" elevation="1">
              <v-spacer />
              <v-icon color="warning" icon="mdi-alert" size="x-large" />
              <v-spacer />
          </v-toolbar>
          <v-card-title class="text-center">Digite a senha da sala:</v-card-title>
          <v-form v-model="isFormValid" @submit.prevent="onSubmit">
            <v-card-text>
              <v-alert v-model="alert" class="my-3" closable :text="alertText" :type="alertType" />
              <v-text-field v-model="senha.value.value" color="primary" label="Senha" :counter="4" :error-messages="senha.errorMessage.value" />
            </v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn :disabled="!isFormValid" class="bg-primary" variant="flat" type="submit" :loading="loadingStartTest">Entrar</v-btn>
              <v-btn class="bg-primary" variant="flat" @click="closeDialogClassPwd">Cancelar</v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </template>
    <!--#################################################################################################################################################-->

  </template>

  <template v-else-if="(typeof $route.params.id !== 'undefined')">

    <!--################################################## APLICAÇÂO PROVA ##############################################################################-->
    <template v-if="$route.params.aPage === 'Prova'">
      <v-container fluid>
        <v-row>
          <v-col>
            <v-card class="mx-auto" min-height="100" prepend-icon="mdi-information">
              <template v-slot:title>Informações</template>
              <v-card-text>
                <p><strong>Atividade Avaliativa:</strong> {{ provaNome }}</p>
                <p><strong>Quantidade de questões:</strong> {{ nQuestoes }}</p>
                <p><strong>Status:</strong> {{ statusNomeProva }}</p>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
        <v-row>
          <v-col>

            <!--############################################### SALA DE ESPERA ###################################################################-->
            <v-card v-if="(statusProva === '1' || provaOK === true)" class="mx-auto" min-height="200" prepend-icon="mdi-alert">
              <template v-slot:title>{{ cardText }}</template>
              <div class="d-flex justify-center">
                <v-progress-circular color="secondary" indeterminate :size="128" />
              </div>
            </v-card>
            <!--##################################################################################################################################-->

            <!--############################################### PROVA INDIVIDUAL #################################################################-->
            <v-card v-else-if="(statusProva === '2')" class="mx-auto" min-height="200">                
              <v-form ref="formAnswer" :disabled="isFormDisabled" @submit.prevent="onSubmitAnswer">
                <v-toolbar color="primary-darken-1" elevation="2"><v-spacer />Questão {{ currentQuestionIndex + 1
                }} de {{ nQuestoes }}<v-spacer /></v-toolbar>
                <v-card-title v-html="sanitizeHtml(currentQuestion.question)" class="mt-2 mx-auto text-wrap" />
                <v-card-text>
                  <v-row v-for="(answer, index) in currentQuestion.answers" :key="index">
                    <v-col cols="5" lg="2" sm="3" xl="1" xs="3">
                      <!--<VeeSelect :name="`answers[${index}]`" :answersLength=currentQuestion.answers.length />-->
                      <v-select v-model="answers[index]" color="primary" label="Peso" :items="getWeights(currentQuestion.answers.length)"
                        :rules="getValidationRules(currentQuestion.answers.length)" />
                    </v-col>
                    <v-col cols="7" lg="10" sm="9" xl="11" xs="9">
                      <span>
                        <strong>{{ getLabel(index) }}) </strong><span v-html="sanitizeHtml(answer.answer)" />
                      </span>
                    </v-col>
                  </v-row>
                  <div v-if="showErrorMessage" class="text-danger">A soma dos pesos tem que dar {{ currentQuestion.answers.length }}.</div>
                </v-card-text>
                <v-card-actions class="mt-auto">
                  <v-btn v-show="(currentQuestionIndex > 0)" class="bg-tertiary" variant="flat" @click="prevQuestion()"><span class="text-white">Anterior</span></v-btn>
                  <v-btn v-show="!isFormDisabled" class="bg-primary" variant="flat" type="submit" :loading="loadingSaveAnswer">Salvar</v-btn>
                  <v-btn v-show="isFormDisabled" class="bg-secondary" variant="flat" @click="nextQuestion()">Próxima</v-btn>
                </v-card-actions>
              </v-form>
            </v-card>
            <!--##################################################################################################################################-->

            <!--################################################ CRIAÇÃO DE GRUPO ################################################################-->
            <template v-else-if="(statusProva === '3')">
              <v-row v-if="loadingStudents">
                <v-col class="d-flex justify-center">
                  <v-progress-circular color="tertiary" indeterminate :size="80" />
                </v-col>
              </v-row>
              <div v-else>
              <v-card v-if="meInGroup === false" class="mx-auto" min-height="200" prepend-icon="mdi-account-group">
                <template v-slot:title>Escolher Grupo</template>
                <v-card-text>
                  <v-data-table v-if="(meInGroup === false)" v-model="selectedStudents" v-model:sort-by="sortByName" 
                    class="table elevation-2" hover item-value="id" show-select
                    items-per-page-text="Itens por página" page-text="{0}-{1} de {2}"
                    :headers="headersClassroom" :items="listStudents" :loading="loadingStudents">
                    <template v-slot:no-data>
                      <v-alert class="my-4" :value="true">
                        <v-icon class="mt-n1 mr-2" color="warning" icon="mdi-alert" /> Desculpe, sem dados para exibir :(
                      </v-alert>
                    </template>
                  </v-data-table>
                </v-card-text>
                <v-card-actions class="ml-2">
                  <v-btn class="bg-primary" variant="flat" @click="createGroup()">Criar Grupo</v-btn>
                </v-card-actions>
              </v-card>
                    
              <v-card v-else-if="(meInGroup === true)" min-height="200" class="mx-auto" prepend-icon="mdi-account-group">
                <template v-slot:title>Aguardando início da atividade avaliativa em equipe.</template>
                <v-card-text>
                  <div class="d-flex justify-center mb-2">
                    <v-progress-circular color="secondary" indeterminate :size="128" />
                  </div>
                  <div class="text-h6">Grupo {{ groupName }} ({{ group.length }}): <br /> {{ group }}</div>
                </v-card-text>
              </v-card></div>
            </template>
            <!--##################################################################################################################################-->

            <!--############################################### PROVA EM GRUPO ###################################################################-->
            <v-card v-else-if="(statusProva === '4' && liderId === $store.state.userId)" class="mx-auto" min-height="200">
              <v-toolbar color="primary-darken-1" elevation="2"><v-spacer />Questão {{ currentQuestionIndex + 1
              }} de {{ nQuestoes }}<v-spacer /></v-toolbar>
              <v-card-title v-html="sanitizeHtml(currentQuestion.question)" class="mt-2 text-wrap" />
              <v-form ref="formAnswer" @submit.prevent="onSubmitGroupAnswer">
                <v-card-text>

                  <v-radio-group v-model="groupAnswer" :disabled="isFormDisabled" :rules="getValidationRules2()">
                    <v-row v-for="(answer, index) in currentQuestion.answers" :key="index">
                      <!--<v-radio-group v-model="answers[index]" :rules="getValidationRules2(answers[index])">-->
                      <v-radio :value="index" :disabled="isRadioDisabled[index]" :style="{ 'color': isRadioDisabled[index] ? 'red' : 'inherit' }">
                        <template v-slot:label>
                          <div>
                            <strong>{{ getLabel(index) }}) </strong><span v-html="sanitizeHtml(answer.answer)" />
                          </div>
                        </template>
                      </v-radio>
                    </v-row>
                  </v-radio-group>
                  
                  <div v-if="showErrorMessage" class="text-danger" />
                </v-card-text>
                <v-card-actions>
                  <v-btn v-show="(currentQuestionIndex > 0)" class="bg-tertiary" variant="flat" @click="prevQuestion()"><span class="text-white">Anterior</span></v-btn>
                  <v-btn v-show="!isFormDisabled" class="bg-primary" variant="flat" type="submit" :loading="loadingSaveGroupAnswer">Salvar</v-btn>
                  <v-btn v-show="isFormDisabled" class="bg-secondary" variant="flat" @click="nextQuestion()">Próxima</v-btn>
                </v-card-actions>
              </v-form>
            </v-card>

            <v-card v-else-if="(statusProva === '4' && liderId != $store.state.userId)" class="mx-auto" min-height="200" prepend-icon="mdi-account-group">
              <template v-slot:title>Aguardando a finalização da atividade avaliativa em equipe.</template>
              <v-card-text>
                <div class="d-flex justify-center mb-2">
                  <v-progress-circular color="secondary" indeterminate :size="128" />
                </div>
                <div class="text-h6">O líder {{ liderName }} está realizando a atividade avaliativa!</div>
              </v-card-text>
            </v-card>
            <!--##################################################################################################################################-->

          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="4">
              <v-card class="mx-auto" min-height="200" prepend-icon="mdi-star">
                  <template v-slot:title>Nota Máxima</template>
                  <v-card-text class="text-center">
                      <v-progress-circular v-if="loadingNM" color="tertiary" indeterminate :size="80" />
                      <div v-else class="text-h1">{{ notaMaxima }}</div>
                  </v-card-text>
              </v-card>
          </v-col>
          <v-col cols="12" sm="4">
              <v-card class="mx-auto" min-height="200" prepend-icon="mdi-percent-outline">
                  <template v-slot:title>Nota Individual</template>
                  <v-card-text class="text-center">
                      <v-progress-circular v-if="loadingNI" color="tertiary" indeterminate :size="80" />
                      <div v-else class="text-h1">{{ notaIndividual }}</div>
                  </v-card-text>
              </v-card>
          </v-col>
          <v-col cols="12" sm="4">
              <v-card class="mx-auto" min-height="200" prepend-icon="mdi-percent-outline">
                  <template v-slot:title>Nota Equipe</template>
                  <v-card-text class="text-center">
                      <v-progress-circular v-if="loadingNE" color="tertiary" indeterminate :size="80" />
                      <div v-else class="text-h1">{{ notaEquipe }}</div>
                  </v-card-text>
              </v-card>
          </v-col>
        </v-row>
      </v-container>

      <v-dialog v-model="dialogGroup" max-width="500px">
          <v-card>
            <v-toolbar class="bg-primary-darken-1" elevation="1">
              <v-spacer />
              <v-icon color="warning" icon="mdi-alert" size="x-large" />
              <v-spacer />
          </v-toolbar>
            <v-card-title class="text-center">Digite o nome do grupo:</v-card-title>
            <v-form ref="formGroup" @submit.prevent="onSubmitGroup">
              <v-card-text>
                <v-alert v-model="alert" class="my-3" closable :text="alertText" :type="alertType" />
                <v-text-field v-model="groupName" color="primary" label="Nome" :rules="requiredField" />
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn class="bg-primary" variant="flat" type="submit" :loading="loadingSaveGroup">Criar</v-btn>
                <v-btn class="bg-primary" variant="flat" @click="closeDialogGroup">Cancelar</v-btn>
                <v-spacer />
              </v-card-actions>
            </v-form>
          </v-card>
      </v-dialog>

    </template>
    <!--#################################################################################################################################################-->

  </template>

  <v-snackbar v-model="snackbar" :color="sbColor">
      {{ sbMessage }}
      <template v-slot:actions>
        <v-btn @click="snackbar = false">
          Fechar
        </v-btn>
      </template>
    </v-snackbar>

</template>

<style type="text/css">
img {
  max-width: 100%;  
  max-height: 100%;
}
.v-data-table.table .v-table__wrapper>table>thead>tr th,
.v-data-table.table .v-table__wrapper>table tbody>tr th {
    background-color: #16324A !important;
    color: white;
}

.v-data-table .v-table__wrapper>table>thead>tr>th.v-data-table__th--sortable:hover,
.v-data-table .v-table__wrapper>table tbody>tr>th.v-data-table__th--sortable:hover {
    color: white;
}

.text-danger {
  color: rgb(176, 0, 32);
  font-size: 12px;
  margin-top: 4px;
  margin-left: 4px;
}
</style>

<script src="@/assets/js/aluno.js" />
